{
  "addSensor": "Ajouter un capteur",
  "linearMovePathTitle": "Chemin de déplacement linéaire",
  "centerPivotPathTitle": "Contour du pivot central",
  "addSensorAlreadyAddedWithSensorNameErrorMessage": "Cet appareil est déjà équipé d'un capteur {{sensorName}} configuré. Veuillez contacter le support FarmHQ si vous avez besoin d'aide.",
  "addSensorCannotAddToExistingErrorMessage": "Ce capteur ne peut pas être ajouté à une configuration existante. Veuillez contacter le support FarmHQ si vous avez besoin d'aide.",
  "addSensorInstructions": "Sélectionnez un capteur à ajouter à la configuration de votre appareil.",
  "addSensorNotCompatibleErrorMessage": "Ce capteur n'est pas compatible avec la configuration de l'appareil. Veuillez contacter le support FarmHQ si vous avez besoin d'aide.",
  "addSensorTitleWithSensorName": "Ajouter la configuration du capteur {{sensorName}}",
  "chooseInstallationType": "Choisissez le type d'installation",
  "choosePressureSensorModelInstructions": "Choisissez le modèle de capteur de pression installé sur votre appareil.",
  "choosePumpTypeInstructions": "Choisissez l'option qui décrit le mieux votre équipement et votre installation.",
  "choosePumpTypeTitle": "Sélectionnez le type de pompe",
  "choosePumpType_pump_off_only": {
    "description": "Pompe d'arrêt uniquement (Diesel, arrêt d'urgence électrique)",
    "label": "Pompe à arrêt uniquement"
  },
  "choosePumpType_pump_on_off": {
    "description": "Contact unique marche/arrêt (Diesel Stage 4, Électrique)",
    "label": "Pompe marche/arrêt"
  },
  "choosePumpType_pump_vfd": {
    "description": "Pompe VFD avec contrôle de vitesse",
    "label": "Pompe à entraînement variable"
  },
  "chooseSensorPortInstructionsWithSensorName": "Choisissez le port de capteur sur lequel le capteur {{sensorName}} est installé.\n\nNotez que des ports de capteur mal appariés empêcheront votre appareil de produire des mesures correctes. En cas de doute, veuillez contacter le support FarmHQ.",
  "chooseSensorPortStageTitle": "Sélectionner le port du capteur",
  "clickSensorToManage": "Cliquez sur un capteur pour afficher ou gérer sa configuration.",
  "clickSensorToManageMobile": "Appuyez sur un capteur pour afficher ou gérer sa configuration.",
  "configurationInfoTitle": "Informations de configuration",
  "configurationRequiredMessage": "Avant d’effectuer cette action, vous devez saisir les informations de configuration de cet appareil.",
  "configurationRequiredTitle": "Configuration requise",
  "configuredSensors": "Capteurs configurés",
  "confirm": "Confirmer",
  "customizeDeviceNameInstructions": "Vous pouvez donner un surnom à votre appareil pour vous aider à l'identifier. Ce nom sera affiché dans l'application FarmHQ. Si vous laissez ce champ vide, l'appareil sera nommé d'après son alias de produit.",
  "customizeDeviceNameStageTitle": "Personnaliser le nom de l'appareil",
  "deleteSensor": "Supprimer le capteur",
  "deleteSensorImpactFunctionalityWarning": "Cela peut avoir des conséquences négatives sur les fonctionnalités de votre appareil.\n\nSi vous n'êtes pas sûr de ce que vous faites, veuillez contacter le support FarmHQ.",
  "deleteSensorSensorIsRequiredMessage": "Ce capteur est nécessaire au fonctionnement de votre appareil et ne peut pas être supprimé. Si vous avez besoin d'aide, veuillez contacter FarmHQ.",
  "deleteSensorTitleWithSensorName": "Confirmer la suppression de la configuration {{sensorName}}",
  "deviceInstallationType": "Type d'installation",
  "deviceName": "Nom de l'appareil",
  "deviceNameInputLabel": "Nom de l'appareil",
  "deviceNameInputPlaceholder": "Entrez un nom pour cet appareil",
  "deviceSetup": "Configuration de l'appareil",
  "doesItHaveAFlowSensor": "L'appareil est-il équipé d'un capteur de débit installé ?",
  "doesItHaveAPressureSensor": "L'appareil est-il équipé d'un capteur de pression ?",
  "edit": "Modifier",
  "editSensorField": "Modifier le champ du capteur",
  "forbidden": "Interdit",
  "hardwareGeneration": "Génération de matériel",
  "helpContentBodyText": "Les configurations d'appareils permettent de configurer votre appareil avec les capteurs et paramètres appropriés. Cela garantit que votre appareil peut suivre et signaler avec précision les données, et peut être utilisé dans les automatisations et les notifications.",
  "hintWithColon": "Indice:",
  "hose": "Tuyau",
  "linkTo": "Configuration",
  "manageSensor": "Gérer le capteur",
  "manageSensorWithSensorName": "Gérer le capteur {{sensorName}}",
  "newConfiguration": "Nouvelle configuration",
  "newDeviceConfiguration": "Nouvelle configuration de l'appareil",
  "newReelConfiguration": "Nouvelle configuration de bobine",
  "noConfiguredSensorsMessage": "Aucun capteur n'est configuré pour cet appareil.",
  "notNow": "Pas maintenant",
  "nozzle": "Ajutage",
  "pathConfigurationLinearTitle": "Configuration du chemin linéaire",
  "pathConfigurationPivotTitle": "Configuration du pivot",
  "pc1PumpSetupStageTitle": "Configuration de la pompe PC1 (héritée)",
  "pressureSensor": "Capteur de pression",
  "pressureSensorModelNameMeas": "MESURES",
  "pressureSensorModelNameOther": "Autre",
  "pressureSensorModelNameSoway": "Soway",
  "pressureSensorModelNameTrafag": "Trafic",
  "pressureSensorModelStageTitle": "Choisissez le modèle de capteur de pression",
  "pressureThresholdsHelpText": "Les seuils de pression aident à déterminer quand un appareil doté d'un centre de pression pompe plus ou moins d'eau que prévu.",
  "pressureThresholdsStageTitle": "Seuils de pression",
  "pumpType": "Type de pompe :",
  "removeFromFarmAreYouSure": "Êtes-vous sûr de vouloir retirer cet appareil de ce compte de ferme ?",
  "removeFromFarmLinkTo": "Retirer de la ferme",
  "removeFromFarmTitle": "Confirmer le retrait de l'appareil",
  "removeFromFarmWarning": "L'appareil sera réinitialisé aux paramètres d'usine et n'apparaîtra plus dans ce compte. Cette action est irréversible.",
  "rename": "Rebaptiser",
  "renameDevice": "Renommer l'appareil",
  "renameThisDevice": "Renommer cet appareil",
  "resetDeviceAreYouSure": "Êtes-vous sûr de vouloir restaurer les paramètres par défaut de cet appareil ?",
  "resetDeviceLinkTo": "Réinitialisation d'usine",
  "resetDeviceTitle": "Confirmer la réinitialisation de l'appareil",
  "resetDeviceYouWillLoseConfigurations": "Vous perdrez toutes les configurations de capteurs et toutes les autres personnalisations. Cette opération est irréversible.",
  "resetDeviceYouWillLoseTriggers": "Toutes les paires d'appareils, les notifications et les automatisations seront également supprimées.",
  "reviewAndSubmitInstructions": "Votre appareil sera configuré avec les paramètres suivants. Vérifiez-les et validez pour enregistrer les modifications.",
  "selectPressureSensorToContinue": "Sélectionnez un modèle de capteur de pression pour continuer. En cas de doute, veuillez contacter le support FarmHQ.",
  "sensorPortHint": "Assurez-vous que le port du capteur est correctement identifié. Des ports de capteur commutés peuvent entraîner des lectures incorrectes.",
  "sensors": "Capteurs",
  "setPressureThresholdInstructions": "Définissez des seuils de pression pour déterminer quand votre équipement pompe plus ou moins d’eau que prévu.",
  "setUp": "Configurer l'appareil",
  "setUpCenterPivot": "Configuration du pivot central",
  "setUpDevice": "Configurer l'appareil",
  "setUpLinearMove": "Configuration du mouvement linéaire",
  "setUpPump": "Configuration de la pompe",
  "setUpReel": "Configuration de la bobine",
  "setUpReelDescription": "Saisissez les informations d'étalonnage de votre moulinet pour assurer un suivi précis de l'irrigation, de l'ETA et d'autres mesures.",
  "setUpSoftHoseTraveler": "Configuration du voyageur à tuyau souple",
  "setUpTravelerSoft": "Configuration du voyageur à tuyau souple",
  "setUpValve": "Configuration de la vanne",
  "spool": "Bobine",
  "thisDeviceAlreadyHasThatSensorWithSensorName": "Cet appareil possédait déjà une configuration {{sensorName}} active. Pour la modifier ou la supprimer, sélectionnez-la dans la liste.",
  "title": "Configuration",
  "unconfiguredDeviceWarning": "Cet appareil n'est pas configuré.",
  "updateConfigurationDataLossWarning": "L'appareil peut également subir une perte de données temporaire pendant la synchronisation des modifications.",
  "updateConfigurationSwitchOnToOffWarning": "La mise à jour de la configuration de l'appareil entraînera l'arrêt du commutateur s'il est actuellement activé.",
  "vfdTrackingSpeedsStageTitle": "Vitesses de suivi VFD",
  "wheelDiameterMmInstructions": "Mesurez le diamètre de la roue et entrez-le ici.",
  "wheelDiameterStageTitle": "Diamètre de la roue",
  "wheelMagnetsStageTitle": "Aimants de roue",
  "wheelNMagnetsInstructions": "Entrez le nombre d'aimants installés sur la roue.",
  "wheelSensorPortInstructions": "Où est installé le capteur de roue ?",
  "wheelSensorPortStageTitle": "Port du capteur de roue",
  "wheelStoppedTimeoutInstructions": "Combien de temps l'appareil doit attendre sans détecter de mouvement de la roue avant de signaler que la roue est arrêtée.",
  "wheelStoppedTimeoutStageTitle": "Délai d'arrêt de la roue",
  "wouldYouLikeToSetLinearPath": "Souhaitez-vous définir le chemin linéaire maintenant ?"
}
